// src/ErrorBoundary.tsx

import React from "react";
import { createBaseErrorPayload, uploadClientError } from "./stdlib-errors";

type ErrorBoundaryProps = {
    children: React.ReactNode;
    fallback?: React.ReactNode;
};

type ErrorBoundaryState = {
    hasError: boolean;
};

export class StdlibErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
    public state: ErrorBoundaryState = {
        hasError: false
    };

    public static getDerivedStateFromError(): ErrorBoundaryState {
        return { hasError: true };
    }

    public componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
        void uploadClientError({
            ...createBaseErrorPayload("react-error-boundary", error.message),
            name: error.name,
            stack: error.stack,
            componentStack: errorInfo.componentStack ?? undefined
        });
    }

    public render(): React.ReactNode {
        if (this.state.hasError) {
            return this.props.fallback ?? (
                <div role="alert">
                    Something went wrong.
                </div>
            );
        }

        return this.props.children;
    }
}